import { ModelBase } from '../../core/model/model-base';

export class UserGroup extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.name = dataContext.name;
      this.users = dataContext.users;
      this.features = dataContext.features;
      this.systemGroup = dataContext.systemGroup;
    }
  }

  name: string;
  users: string[] = [];
  features: string[] = [];
  systemGroup: boolean;
}
